const getters = {
  roles: ({ roles }) => roles,
  newRole: ({ newRole }) => newRole,
  selectedPermissions: ({ selectedPermissions }) => selectedPermissions
}

export default getters
